/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminCargoHold,
  AdminCargoHolds,
  CargoHoldInput,
  ListCargoHoldsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Cargo Holds list
 */
export const listCargoHolds = (
    params?: MaybeRefOrGetter<ListCargoHoldsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminCargoHolds>(
      {url: `/cargo-holds`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCargoHoldsQueryKey = (params?: MaybeRefOrGetter<ListCargoHoldsParams>,) => {
    return [
    'cargo-holds', ...(params ? [params] : [])
    ] as const;
    }


export const getListCargoHoldsQueryOptions = <TData = Awaited<ReturnType<typeof listCargoHolds>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListCargoHoldsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCargoHolds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCargoHoldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCargoHolds>>> = ({ signal }) => listCargoHolds(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCargoHolds>>, TError, TData>
}

export type ListCargoHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof listCargoHolds>>>
export type ListCargoHoldsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Cargo Holds list
 */

export function useListCargoHolds<TData = Awaited<ReturnType<typeof listCargoHolds>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListCargoHoldsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCargoHolds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCargoHoldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Cargo Hold
 */
export const updateCargoHold = (
    id: MaybeRefOrGetter<string>,
    cargoHoldInput: MaybeRefOrGetter<CargoHoldInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
cargoHoldInput = toValue(cargoHoldInput);

      return axiosClient<AdminCargoHold>(
      {url: `/cargo-holds/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cargoHoldInput, signal
    },
      );
    }




export const getUpdateCargoHoldMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCargoHold>>, TError,{id: string;data: CargoHoldInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCargoHold>>, TError,{id: string;data: CargoHoldInput}, TContext> => {

const mutationKey = ['updateCargoHold'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCargoHold>>, {id: string;data: CargoHoldInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCargoHold(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCargoHoldMutationResult = NonNullable<Awaited<ReturnType<typeof updateCargoHold>>>
    export type UpdateCargoHoldMutationBody = CargoHoldInput
    export type UpdateCargoHoldMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Cargo Hold
 */
export const useUpdateCargoHold = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCargoHold>>, TError,{id: string;data: CargoHoldInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCargoHold>>,
        TError,
        {id: string;data: CargoHoldInput},
        TContext
      > => {
      return useMutation(getUpdateCargoHoldMutationOptions(options), queryClient);
    }
